module.exports = __webpack_public_path__ + "img/IE.1b45bace.svg";